module.exports = __webpack_public_path__ + "assets/img/logo.ee64ac55.png";